"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_content_loader_1 = __importDefault(require("react-content-loader"));
const utils_1 = require("./utils");
const WebContentLoader = (props) => {
    const { children } = props, otherProps = __rest(props, ["children"]);
    const extraProps = (0, utils_1.updateTestId)(otherProps);
    // We really don't want to explictly specify all props `ContentLoader` supports
    // eslint-disable-next-line react/jsx-props-no-spreading
    return react_1.default.createElement(react_content_loader_1.default, Object.assign({}, extraProps), children);
};
exports.default = WebContentLoader;
//# sourceMappingURL=ContentLoader.js.map